// @ts-nocheck

import { css } from 'styled-components';

import { Target } from '../../../client';

const ImageAsButtonsBehaviour = css`
  ${!Target.__MOBILE__
    ? css`
        transition: none 150ms ease-in-out;
        transition-property: filter, transform;

        &:hover {
          filter: brightness(110%);
        }
        &:active {
          transform: scale(0.95);
        }
      `
    : undefined}
`;

const SharedStyle = {
  ImageAsButtonsBehaviour,
};

export default SharedStyle;
